var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C22.5 17.796 17.8012 22.5 12 22.5C6.19875 22.5 1.5 17.796 1.5 12C1.5 6.19875 6.19875 1.5 12 1.5C17.8012 1.5 22.5 6.19875 22.5 12Z",
    fill: "#283544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9216 9.34304C16.8643 9.37646 15.5003 10.0819 15.5003 11.6459C15.5646 13.4296 17.2216 14.0551 17.25 14.0551C17.2216 14.0885 16.9998 14.9072 16.343 15.7654C15.8217 16.5047 15.2432 17.25 14.3646 17.25C13.5289 17.25 13.2289 16.7573 12.2646 16.7573C11.229 16.7573 10.936 17.25 10.1431 17.25C9.26458 17.25 8.64315 16.4647 8.09345 15.7324C7.37932 14.7739 6.77233 13.2698 6.7509 11.8256C6.73646 11.0603 6.89392 10.308 7.29361 9.66904C7.85774 8.77699 8.86489 8.17143 9.96473 8.15146C10.8074 8.12498 11.5574 8.6906 12.0717 8.6906C12.5646 8.6906 13.486 8.15146 14.5286 8.15146C14.9786 8.1519 16.1786 8.27822 16.9216 9.34304ZM12.0005 7.99866C11.8505 7.29978 12.2646 6.60089 12.6503 6.15508C13.1432 5.61594 13.9216 5.25 14.5929 5.25C14.6357 5.94889 14.3641 6.63432 13.8787 7.13352C13.4432 7.67266 12.6932 8.07853 12.0005 7.99866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3d6d859efb16b351aabadfa74930cb1f.svg";
export { ForwardRef as ReactComponent };